import { createContext } from 'react';

const AccessControl = createContext({
    role: '',
    permissions: []
});

export { AccessControl }